module.exports = __webpack_public_path__ + "static/img/15areaA_7.e90a9f2.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/15areaA_7.png
// module id = 1016
// module chunks = 1